module.exports = __webpack_public_path__ + "img/home-illustration1.2e3e0e44.svg";